
export default {
    name: 'LeeCell',
    data() {
        return {

        }
    },
    methods: {
        goto(url){
            if(this.del){
                this.$emit('del')
                return
            }
            if(url.length>0){
                location.href=url
            }

        }

    },
    props: {
        title: {
            type: String,
            default: 'Cells的标题' //默认default
        },
        footer: {
            type: String,
            default: 'Cells底部的文字' //默认default
        },
        url: {
            type: String,
            default: '' //默认default
        },
        icon: {
            type: String,
            default: '' //默认default
        },
        del: {
            type: Boolean,
            default: false
        }
    }
};
